"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("@trs/utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDraftWysiwyg = require("react-draft-wysiwyg");
require("react-draft-wysiwyg/dist/react-draft-wysiwyg.css");
var _InputError = _interopRequireDefault(require("../errors/InputError"));
var _icon = _interopRequireDefault(require("../icon"));
var _RichTextarea = _interopRequireDefault(require("./RichTextarea.style"));
var _RichTextarea2 = require("./RichTextarea.helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var RichTextarea = /*#__PURE__*/function (_Component) {
  _inherits(RichTextarea, _Component);
  var _super = _createSuper(RichTextarea);
  function RichTextarea(props) {
    var _this;
    _classCallCheck(this, RichTextarea);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onEditorStateChange", function (editorState) {
      var onChange = _this.props.onChange;
      var initialValue = _this.state.initialValue;
      var markup = (0, _RichTextarea2.getMarkupFromEditorState)(editorState);
      var plainText = editorState.getCurrentContent().getPlainText();
      _this.setState({
        editorState: editorState
      });
      _this.setState({
        isDirty: markup !== initialValue
      }, onChange(markup, plainText));
    });
    var _initialValue = props.initialValue ? (0, _utils.safeTrim)(props.initialValue) : undefined;
    var value = (0, _utils.safeTrim)(props.value);
    _this.state = {
      editorState: (0, _RichTextarea2.getEditorState)(value),
      initialValue: _initialValue || value,
      isDirty: false,
      hasLengthError: false
    };
    return _this;
  }
  _createClass(RichTextarea, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
        editorState = _this$state.editorState,
        hasLengthError = _this$state.hasLengthError;
      var _this$props = this.props,
        readOnly = _this$props.readOnly,
        error = _this$props.error,
        disabled = _this$props.disabled,
        ariaDescribedBy = _this$props.ariaDescribedBy,
        placeholder = _this$props.placeholder,
        placeholderPosition = _this$props.placeholderPosition,
        className = _this$props.className,
        toolbar = _this$props.toolbar,
        expanded = _this$props.expanded,
        onToggleText = _this$props.onToggleText,
        value = _this$props.value,
        collapsableText = _this$props.collapsableText;
      var hasError = !(0, _utils.isBlank)(error);
      var textLength = value ? value.length : 0;
      return /*#__PURE__*/_react["default"].createElement(_RichTextarea["default"], {
        hasError: hasError || hasLengthError,
        isReadOnly: readOnly,
        isDisabled: disabled,
        className: className,
        placeholderPosition: placeholderPosition
      }, this.props.childContainer, !(collapsableText && _utils.isMobile && textLength === 0) && /*#__PURE__*/_react["default"].createElement(_reactDraftWysiwyg.Editor, {
        toolbarHidden: readOnly || disabled,
        editorState: editorState,
        readOnly: readOnly || disabled,
        wrapperClassName: "wrapper-class",
        editorClassName: "editor-class",
        toolbarClassName: "toolbar-class",
        onEditorStateChange: this.onEditorStateChange,
        toolbar: (0, _RichTextarea2.getToolbarConfig)(toolbar),
        ariaDescribedBy: ariaDescribedBy,
        placeholder: placeholder,
        stripPastedStyles: true
      }), hasError && /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
        className: "rdw-inputError",
        message: error
      }), disabled && collapsableText && _utils.isMobile && /*#__PURE__*/_react["default"].createElement("div", {
        className: "collapsable-icon-container"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        icon: "ion-chevron-".concat(expanded ? 'up' : 'down'),
        collapsable: true,
        hasError: hasError || hasLengthError,
        onClick: onToggleText,
        size: 12
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var initialValue = props.initialValue ? (0, _utils.safeTrim)(props.initialValue) : undefined;
      var value = (0, _utils.safeTrim)(props.value);

      // Changing the initial value the text will be reverted to if the prop is passed.
      if (initialValue && initialValue !== state.initialValue) {
        var editorState = (0, _RichTextarea2.getEditorState)(value);
        return {
          editorState: editorState,
          initialValue: initialValue,
          isDirty: false
        };
      }

      // Reverts the text to the initial value.
      if (value === state.initialValue && state.isDirty) {
        var _editorState = (0, _RichTextarea2.getEditorState)(value);
        return {
          editorState: _editorState,
          initialValue: value,
          isDirty: false
        };
      }

      // Changes text to initial value for mobile view with collapsable text
      if (value !== state.initialValue && props.collapsableText) {
        var _editorState2 = (0, _RichTextarea2.getEditorState)(value);
        return {
          editorState: _editorState2,
          initialValue: value
        };
      }
      return null;
    }
  }]);
  return RichTextarea;
}(_react.Component);
RichTextarea.propTypes = {
  disabled: _propTypes["default"].bool,
  error: _propTypes["default"].string,
  readOnly: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  editorState: _propTypes["default"].shape({}),
  initialValue: _propTypes["default"].string,
  value: _propTypes["default"].string,
  ariaDescribedBy: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  placeholderPosition: _propTypes["default"].oneOf(['top', 'center']),
  className: _propTypes["default"].string,
  toolbar: _propTypes["default"].shape({}),
  childContainer: _propTypes["default"].element,
  expanded: _propTypes["default"].bool,
  onToggleText: _propTypes["default"].func,
  collapsableText: _propTypes["default"].bool
};
RichTextarea.defaultProps = {
  disabled: false,
  error: undefined,
  readOnly: false,
  onChange: function onChange() {},
  editorState: undefined,
  initialValue: undefined,
  value: undefined,
  placeholder: '',
  placeholderPosition: 'center',
  className: '',
  toolbar: {
    options: []
  },
  childContainer: null,
  expanded: false,
  onToggleText: function onToggleText() {
    return null;
  },
  collapsableText: false,
  ariaDescribedBy: ''
};
RichTextarea.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onEditorStateChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "editorState",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "RichTextarea",
  "props": {
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "error": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "readOnly": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "editorState": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "initialValue": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "placeholder": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "placeholderPosition": {
      "defaultValue": {
        "value": "'center'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'top'",
          "computed": false
        }, {
          "value": "'center'",
          "computed": false
        }]
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "toolbar": {
      "defaultValue": {
        "value": "{\r\n  options: [],\r\n}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "childContainer": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "element"
      },
      "required": false
    },
    "expanded": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onToggleText": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "collapsableText": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "ariaDescribedBy": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var _default = RichTextarea;
exports["default"] = _default;